module.exports = __webpack_public_path__ + "img/40_38_061_160.fd4b1947.jpg";